import styled from 'styled-components'

export const RowPlaceholder = styled.div<{ height: number }>`
  grid-column: 1 / -1;
  height: ${p => `${p.height}px`};
`
